<template>
  <div>
    <v-snackbar v-model="snackbar" :value="snackbarMessage" timeout="4000">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="closeSnackbar">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  // props: ["responseMessage"],
  methods: {
    closeSnackbar() {
      this.$store.dispatch("addSnackbar", false);
      this.$store.dispatch("addSnackbarMessage", "");
    },
  },
  computed: {
    snackbar: {
      // return this.$store.getters.getSnackbar;

      get() {
        return this.$store.getters.getSnackbar;
      },
      set(val) {
        this.$store.commit("setSnackbar", val);
      },
    },
    snackbarMessage: {
      // return this.$store.getters.getSnackbarMessage;
      get() {
        return this.$store.getters.getSnackbarMessage;
      },
      set(val) {
        this.$store.commit("setSnackbarMessage", val);
      },
    },
  },

  watch: {
    snackbarMessage() {
      setTimeout(() => {
        this.$store.dispatch("addSnackbar", false);
        this.$store.dispatch("addSnackbarMessage", "");
      }, 4000);
    },
  },
};
</script>
